import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { NonWorkingDayStore } from "@app/services/store/roster/non-working-day-store";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Roster } from "@app/models/rest/roster/roster";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NonWorkingDay } from "@app/models/rest/roster/non-working-day";
import moment from "moment";
import {
  ColumnConfig,
  DateColumnConfig,
  WidgetColumnConfig
} from "@bryntum/grid-thin";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-non-working-day-list",
  templateUrl: "./non-working-day-list.component.html",
  styleUrls: ["./non-working-day-list.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class NonWorkingDayListComponent
  extends BaseDataTablePageDirective<NonWorkingDay>
  implements OnInit
{
  nonWorkingDayStore: NonWorkingDayStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public roster: Roster;
  @Input()
  public columns: (ColumnConfig | DateColumnConfig | WidgetColumnConfig)[] = [
    {
      field: "date",
      text: "Date",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      renderer: ({ value }) => {
        console.log("Formating date for render", value);
        return moment(value).format("DD/MM/YYYY");
      },
      editor: {
        format: "DD/MM/YYYY",
        keepTime: "12:00"
      }
    },
    {
      field: "description",
      text: "Description",
      flex: 1,
      editor: true
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const nonWorkingDayStore = inject(NonWorkingDayStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      nonWorkingDayStore,
      store,
      dialog,
      "NonWorkingDay",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.nonWorkingDayStore = nonWorkingDayStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.roster) {
      this.gridStore.parentField = "roster.id";
      this.gridStore.parentId = this.roster.id;
      this.gridStore.parentResource = this.roster;
      this.gridStore.parentRel = "roster";
      this.gridStore.autoCommit = false;
      this.gridStore.load({});
    }
  }

  addRow() {
    this.gridStore.insert(0, {
      description: "",
      date: moment().toDate()
    });
  }
}
